export enum FBSDK_ERROR_CODES {
    UserClosedPopup = "USER_INPUT",
    SameContext = "SAME_CONTEXT",
}
